import { useMemo } from "react";

export default function LastEdited({ params }) {
  const centerStyle = "center_perfect";

  const formattedDate = useMemo(() => {
    // 1. Safety check: Handle missing params or null/undefined values
    if (!params || params.value === null || params.value === undefined) {
      return "-";
    }

    const { value } = params;
    const date = new Date(value);

    // 2. Validation: Check if the date is valid.
    // A Date object can exist but have a Time of 'NaN', which crashes Intl.
    if (isNaN(date.getTime())) {
      return "Invalid Date";
    }
    //edited
    try {
      const formatter = new Intl.DateTimeFormat("id-ID", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
        timeZone: "Asia/Jakarta",
      });

      return formatter.format(date);
    } catch (error) {
      // Fallback if Intl fails unexpectedly
      console.error("Date formatting failed", error);
      return "Format Error";
    }

    // 3. Optimization: Depend on 'params.value', not the whole 'params' object
  }, [params]);

  return (
    <span
      className={`hide-scrollbar ${centerStyle}`}
      style={{ height: "100%", overflowY: "auto" }}
    >
      {formattedDate}
    </span>
  );
}
